
export const TYPE_SERV_PLAN = 0;
export const TYPE_ADD_TASKS = 1;
export const TYPE_WEAR_PARTS = 2;
